import React from 'react'
import { TypographyTypes } from '../../constants'
import Isologo from './Isologo'
import Typography from '../Typography'

const Logo = ({ variant }) => {
    return (
        <Typography
            type={TypographyTypes.H1}
            className='rds-logo rds-flexbox align-center'
            variant={variant}
        >
            <Isologo className='rds-m_right__sm' />
            <span>reango</span>
        </Typography>
    )
}

export default Logo
